import { computed } from 'vue'
import { useConfig } from '@/composables/useConfig'
import { useI18n } from 'vue-i18n'
import enums from '@/plugins/enums.js'

export const useOptionsFormatter = () => {
  const config = useConfig()
  const { t, te } = useI18n()

  const buildingTypeOptions = computed(() => {
    // The icons are defined here to maintain the order of the options, which is not guaranteed from the BE config
    const icons = {
      [enums.buildingTypes.HOUSE]: 'mdi-home',
      [enums.buildingTypes.NEW_HOUSE]: 'mdi-home',
      [enums.buildingTypes.APARTMENT]: 'mdi-domain',
      [enums.buildingTypes.NEW_APARTMENT]: 'mdi-domain',
      [enums.buildingTypes.GARAGE]: 'mdi-parking',
      [enums.buildingTypes.APARTMENT_BLOCK]: 'mdi-office-building-outline',
      [enums.buildingTypes.COMMERCIAL]: 'mdi-garage-variant',
      [enums.buildingTypes.CONSTRUCTION_PLOT]: 'mdi-vector-square',
      [enums.buildingTypes.OTHER_PLOT]: 'mdi-shape',
      [enums.buildingTypes.OTHER]: 'mdi-dots-horizontal',
    }

    const order = Object.keys(icons)
    const allowedBuildingTypes = [...config.ALL_ALLOWED_BUILDING_TYPES].sort(
      (a, b) => order.indexOf(a) - order.indexOf(b)
    )

    return allowedBuildingTypes.map((item) => ({
      value: item,
      label: te(`value.building_type.${item}`) ? t(`value.building_type.${item}`) : item,
      caption: te(`value.building_type.${item}_tooltip`) ? t(`value.building_type.${item}_tooltip`) : null,
      icon: icons[item],
      ariaLabel: `building type: ${item}`,
    }))
  })

  const valuationTypeOptions = computed(() => {
    return Object.values(enums.valuationTypes).map((item) => ({
      value: item,
      label: te(`value.short.${item}`) ? t(`value.short.${item}`) : item,
      ariaLabel: `type: ${item}`,
    }))
  })

  const requestStatusOptions = computed(() => {
    return Object.values(enums.requestStatus).map((item) => ({
      value: item,
      label: te(`status.${item}`) ? t(`status.${item}`) : item,
      ariaLabel: `status: ${item}`,
    }))
  })

  const languageOptions = computed(() => {
    return Object.values(enums.languages).map((item) => ({
      value: item,
      label: te(`language.${item}`) ? t(`language.${item}`) : item,
      ariaLabel: `language: ${item}`,
    }))
  })

  return {
    buildingTypeOptions,
    valuationTypeOptions,
    requestStatusOptions,
    languageOptions,
  }
}
